import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import RuleIcon from '@mui/icons-material/Rule';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CategoryIcon from '@mui/icons-material/Category';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import GroupsIcon from '@mui/icons-material/Groups';
import DevicesIcon from '@mui/icons-material/Devices';
import StorefrontIcon from '@mui/icons-material/Storefront';
import type { SvgIconComponent } from '@mui/icons-material';

export interface MenuItem {
  displayName: string;
  path: string;
  icon: SvgIconComponent;
  /** Grouped under a heading in the drawer. Ungrouped items sit at the top. */
  group?: string;
}

/**
 * The navigable surface.
 *
 * The vocabulary screens are grouped under Configuration because they are administration, not daily
 * work — an operator lives in the catalogue and visits these rarely. Keeping them visible rather than
 * buried is deliberate: the product's claim is that validation and vocabularies are data rather than
 * code, and that claim is only credible if you can see and change them.
 */
export const MENU_ITEMS: Record<string, MenuItem> = {
  CATALOGUE: {
    displayName: 'Catalogue',
    path: '/catalogue',
    icon: CollectionsBookmarkIcon,
  },
  RULES: {
    displayName: 'Validation rules',
    path: '/rules',
    icon: RuleIcon,
    group: 'Configuration',
  },
  GENRES: {
    displayName: 'Genres',
    path: '/config/genres',
    icon: CategoryIcon,
    group: 'Configuration',
  },
  RATINGS: {
    displayName: 'Ratings',
    path: '/config/ratings',
    icon: StarBorderIcon,
    group: 'Configuration',
  },
  SHOW_TYPES: {
    displayName: 'Show types',
    path: '/config/show-types',
    icon: LiveTvIcon,
    group: 'Configuration',
  },
  AUDIENCES: {
    displayName: 'Audiences',
    path: '/config/audiences',
    icon: GroupsIcon,
    group: 'Configuration',
  },
  DEVICE_TYPES: {
    displayName: 'Device types',
    path: '/config/device-types',
    icon: DevicesIcon,
    group: 'Configuration',
  },
  CATEGORIES: {
    displayName: 'Categories',
    path: '/config/categories',
    icon: AccountTreeIcon,
    group: 'Configuration',
  },
  PROVIDERS: {
    displayName: 'Providers',
    path: '/config/providers',
    icon: StorefrontIcon,
    group: 'Configuration',
  },
};
